import DataGrid, {Column} from "devextreme-react/data-grid";
import {Link} from "react-router-dom";

export default function BackOrderedOrdersGrid(props: { records: [] }) {

	return (
		<DataGrid
			className={'dx-card wide-card'}
			dataSource={props.records}
			allowColumnReordering={true}
			allowColumnResizing={true}
			showBorders={true}
			showColumnLines={true}
			rowAlternationEnabled={true}
			columnAutoWidth={false}
			keyExpr={'materialOrderID'}
		>

			<Column
				dataField={'moNumber'}
				caption={'Material Order #'}
				dataType="string"
				cellRender={(cell: any) => {
					if (cell.data.retailOrderID)
						return <Link to={`/cfi/retail-order/${cell.data.retailOrderID}/130/${cell.data.materialOrderID}`}>
							{cell.data.moNumber}
						</Link>;
					else
						return <Link to={`/cfi/material-order/${cell.data.materialOrderID}`}>
							{cell.data.moNumber}
						</Link>;
				}}
			/>
			<Column
				dataField={'projectNumber'}
				caption={'Project #'}
				dataType="string"
			/>
			<Column
				dataField={'productLine'}
				caption={'Product Line'}
				dataType="string"
			/>
			<Column
				dataField={'customerName'}
				caption={'Customer Name'}
				dataType="string"
			/>
			<Column
				dataField={'customerAddress'}
				caption={'Address'}
				dataType="string"
			/>
			<Column
				dataField={'customerCity'}
				caption={'City, State'}
				dataType="string"
				calculateDisplayValue={(row) => {
					if (row.customerCity && row.customerState)
						return row.customerCity + ', ' + row.customerState;
					else
						return '';
				}}
			/>
			<Column
				dataField={'customerZip'}
				caption={'Zip'}
				dataType="string"
			/>

		</DataGrid>
	);
}
